import { render, staticRenderFns } from "./AI-Tool-Result.vue?vue&type=template&id=2371fd4c&scoped=true&"
import script from "./AI-Tool-Result.ts?vue&type=script&lang=js&"
export * from "./AI-Tool-Result.ts?vue&type=script&lang=js&"
import style0 from "./AI-Tool-Result.less?vue&type=style&index=0&id=2371fd4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2371fd4c",
  null
  
)

export default component.exports